import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router'
import './App.css';
import Payment from './components/Payment';
import Testimonial from './components/Testimonial';
import LoaSigning from './components/LoaSigning';
import LoaLawyer from './components/LoaLawyer';
import qs from 'qs'

export default class App extends Component {
  renderRedirection=(oldUrl, newUrl)=>{
    return <Route path={`/${oldUrl}`} render={() => (
      <Redirect to={{
        pathname : `/${newUrl}`,
        search : window.location.search
      }}/>
    )}/>
  }
  render() {
    const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    const id = queryParams.id

    return (
      <Switch>
        <Route exact path="/payment" component={Payment} />
        {this.renderRedirection("Payment", "payment")}
        <Route exact path="/testimonial" component={Testimonial} />
        {this.renderRedirection("POA/TestimonialForm", "testimonial")}
        <Route exact path="/loa-sign" component={LoaSigning} />
        {this.renderRedirection("POA/ViewPOA", "loa-sign")}
        <Route
          exact
          path={'/loa-lawyer'}
          render={() => {
            return <Redirect to={`/loa-lawyer/${id}`} />;
          }}
        />
        <Route path="/loa-lawyer/:id" component={LoaLawyer} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js